var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import cs from 'classnames';
import { Box } from 'ui-kit/box';
import styles from './mobile-menu-overlay.module.scss';
export var MobileMenuOverlay = function (_a) {
    var _b;
    var isOpen = _a.isOpen, children = _a.children, onClose = _a.onClose, rest = __rest(_a, ["isOpen", "children", "onClose"]);
    var isHiddenScrollRef = useRef(false);
    useEffect(function () {
        var close = function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            window.addEventListener('keydown', close);
            if (document.body.style.overflow === 'hidden') {
                isHiddenScrollRef.current = true;
            }
            else {
                document.body.style.overflow = 'hidden';
            }
        }
        return function () {
            if (isHiddenScrollRef.current) {
                isHiddenScrollRef.current = false;
            }
            else {
                document.body.style.overflow = 'unset';
            }
            window.removeEventListener('keydown', close);
        };
    }, [onClose, isOpen]);
    return (_jsx(Box, __assign({ className: cs(styles.modalMenuOverlay, (_b = {},
            _b[styles.active] = isOpen,
            _b)) }, rest, { children: children })));
};
